import type { Task } from '../../task/Task'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class LinkWorkOrderTaskArgs extends ActionArgs {
  @Field(() => String)
  workOrderId: string

  @Field(() => [GraphQLJSON])
  tasks: Task[]
}

export interface ILinkWorkOrderTask extends IAction<WorkOrder, LinkWorkOrderTaskArgs> {}
